const O = globalThis, L = O.ShadowRoot && (O.ShadyCSS === void 0 || O.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, rt = Symbol(), F = /* @__PURE__ */ new WeakMap();
let ht = class {
  constructor(t, e, i) {
    if (this._$cssResult$ = !0, i !== rt) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t, this.t = e;
  }
  get styleSheet() {
    let t = this.o;
    const e = this.t;
    if (L && t === void 0) {
      const i = e !== void 0 && e.length === 1;
      i && (t = F.get(e)), t === void 0 && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), i && F.set(e, t));
    }
    return t;
  }
  toString() {
    return this.cssText;
  }
};
const ct = (o) => new ht(typeof o == "string" ? o : o + "", void 0, rt), lt = (o, t) => {
  if (L) o.adoptedStyleSheets = t.map(((e) => e instanceof CSSStyleSheet ? e : e.styleSheet));
  else for (const e of t) {
    const i = document.createElement("style"), r = O.litNonce;
    r !== void 0 && i.setAttribute("nonce", r), i.textContent = e.cssText, o.appendChild(i);
  }
}, J = L ? (o) => o : (o) => o instanceof CSSStyleSheet ? ((t) => {
  let e = "";
  for (const i of t.cssRules) e += i.cssText;
  return ct(e);
})(o) : o;
const { is: bt, defineProperty: pt, getOwnPropertyDescriptor: ut, getOwnPropertyNames: kt, getOwnPropertySymbols: ft, getPrototypeOf: vt } = Object, z = globalThis, K = z.trustedTypes, xt = K ? K.emptyScript : "", mt = z.reactiveElementPolyfillSupport, E = (o, t) => o, R = { toAttribute(o, t) {
  switch (t) {
    case Boolean:
      o = o ? xt : null;
      break;
    case Object:
    case Array:
      o = o == null ? o : JSON.stringify(o);
  }
  return o;
}, fromAttribute(o, t) {
  let e = o;
  switch (t) {
    case Boolean:
      e = o !== null;
      break;
    case Number:
      e = o === null ? null : Number(o);
      break;
    case Object:
    case Array:
      try {
        e = JSON.parse(o);
      } catch {
        e = null;
      }
  }
  return e;
} }, V = (o, t) => !bt(o, t), Z = { attribute: !0, type: String, converter: R, reflect: !1, useDefault: !1, hasChanged: V };
Symbol.metadata ??= Symbol("metadata"), z.litPropertyMetadata ??= /* @__PURE__ */ new WeakMap();
class y extends HTMLElement {
  static addInitializer(t) {
    this._$Ei(), (this.l ??= []).push(t);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t, e = Z) {
    if (e.state && (e.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((e = Object.create(e)).wrapped = !0), this.elementProperties.set(t, e), !e.noAccessor) {
      const i = Symbol(), r = this.getPropertyDescriptor(t, i, e);
      r !== void 0 && pt(this.prototype, t, r);
    }
  }
  static getPropertyDescriptor(t, e, i) {
    const { get: r, set: s } = ut(this.prototype, t) ?? { get() {
      return this[e];
    }, set(n) {
      this[e] = n;
    } };
    return { get: r, set(n) {
      const d = r?.call(this);
      s?.call(this, n), this.requestUpdate(t, d, i);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    return this.elementProperties.get(t) ?? Z;
  }
  static _$Ei() {
    if (this.hasOwnProperty(E("elementProperties"))) return;
    const t = vt(this);
    t.finalize(), t.l !== void 0 && (this.l = [...t.l]), this.elementProperties = new Map(t.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(E("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(E("properties"))) {
      const e = this.properties, i = [...kt(e), ...ft(e)];
      for (const r of i) this.createProperty(r, e[r]);
    }
    const t = this[Symbol.metadata];
    if (t !== null) {
      const e = litPropertyMetadata.get(t);
      if (e !== void 0) for (const [i, r] of e) this.elementProperties.set(i, r);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [e, i] of this.elementProperties) {
      const r = this._$Eu(e, i);
      r !== void 0 && this._$Eh.set(r, e);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(t) {
    const e = [];
    if (Array.isArray(t)) {
      const i = new Set(t.flat(1 / 0).reverse());
      for (const r of i) e.unshift(J(r));
    } else t !== void 0 && e.push(J(t));
    return e;
  }
  static _$Eu(t, e) {
    const i = e.attribute;
    return i === !1 ? void 0 : typeof i == "string" ? i : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    this._$ES = new Promise(((t) => this.enableUpdating = t)), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), this.constructor.l?.forEach(((t) => t(this)));
  }
  addController(t) {
    (this._$EO ??= /* @__PURE__ */ new Set()).add(t), this.renderRoot !== void 0 && this.isConnected && t.hostConnected?.();
  }
  removeController(t) {
    this._$EO?.delete(t);
  }
  _$E_() {
    const t = /* @__PURE__ */ new Map(), e = this.constructor.elementProperties;
    for (const i of e.keys()) this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
    t.size > 0 && (this._$Ep = t);
  }
  createRenderRoot() {
    const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return lt(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach(((t) => t.hostConnected?.()));
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    this._$EO?.forEach(((t) => t.hostDisconnected?.()));
  }
  attributeChangedCallback(t, e, i) {
    this._$AK(t, i);
  }
  _$ET(t, e) {
    const i = this.constructor.elementProperties.get(t), r = this.constructor._$Eu(t, i);
    if (r !== void 0 && i.reflect === !0) {
      const s = (i.converter?.toAttribute !== void 0 ? i.converter : R).toAttribute(e, i.type);
      this._$Em = t, s == null ? this.removeAttribute(r) : this.setAttribute(r, s), this._$Em = null;
    }
  }
  _$AK(t, e) {
    const i = this.constructor, r = i._$Eh.get(t);
    if (r !== void 0 && this._$Em !== r) {
      const s = i.getPropertyOptions(r), n = typeof s.converter == "function" ? { fromAttribute: s.converter } : s.converter?.fromAttribute !== void 0 ? s.converter : R;
      this._$Em = r;
      const d = n.fromAttribute(e, s.type);
      this[r] = d ?? this._$Ej?.get(r) ?? d, this._$Em = null;
    }
  }
  requestUpdate(t, e, i) {
    if (t !== void 0) {
      const r = this.constructor, s = this[t];
      if (i ??= r.getPropertyOptions(t), !((i.hasChanged ?? V)(s, e) || i.useDefault && i.reflect && s === this._$Ej?.get(t) && !this.hasAttribute(r._$Eu(t, i)))) return;
      this.C(t, e, i);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$EP());
  }
  C(t, e, { useDefault: i, reflect: r, wrapped: s }, n) {
    i && !(this._$Ej ??= /* @__PURE__ */ new Map()).has(t) && (this._$Ej.set(t, n ?? e ?? this[t]), s !== !0 || n !== void 0) || (this._$AL.has(t) || (this.hasUpdated || i || (e = void 0), this._$AL.set(t, e)), r === !0 && this._$Em !== t && (this._$Eq ??= /* @__PURE__ */ new Set()).add(t));
  }
  async _$EP() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (e) {
      Promise.reject(e);
    }
    const t = this.scheduleUpdate();
    return t != null && await t, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
        for (const [r, s] of this._$Ep) this[r] = s;
        this._$Ep = void 0;
      }
      const i = this.constructor.elementProperties;
      if (i.size > 0) for (const [r, s] of i) {
        const { wrapped: n } = s, d = this[r];
        n !== !0 || this._$AL.has(r) || d === void 0 || this.C(r, void 0, s, d);
      }
    }
    let t = !1;
    const e = this._$AL;
    try {
      t = this.shouldUpdate(e), t ? (this.willUpdate(e), this._$EO?.forEach(((i) => i.hostUpdate?.())), this.update(e)) : this._$EM();
    } catch (i) {
      throw t = !1, this._$EM(), i;
    }
    t && this._$AE(e);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    this._$EO?.forEach(((e) => e.hostUpdated?.())), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$EM() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$Eq &&= this._$Eq.forEach(((e) => this._$ET(e, this[e]))), this._$EM();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
}
y.elementStyles = [], y.shadowRootOptions = { mode: "open" }, y[E("elementProperties")] = /* @__PURE__ */ new Map(), y[E("finalized")] = /* @__PURE__ */ new Map(), mt?.({ ReactiveElement: y }), (z.reactiveElementVersions ??= []).push("2.1.1");
const j = globalThis, T = j.trustedTypes, G = T ? T.createPolicy("lit-html", { createHTML: (o) => o }) : void 0, ot = "$lit$", x = `lit$${Math.random().toFixed(9).slice(2)}$`, st = "?" + x, gt = `<${st}>`, w = document, C = () => w.createComment(""), P = (o) => o === null || typeof o != "object" && typeof o != "function", q = Array.isArray, wt = (o) => q(o) || typeof o?.[Symbol.iterator] == "function", D = `[ 	
\f\r]`, A = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, Q = /-->/g, X = />/g, m = RegExp(`>|${D}(?:([^\\s"'>=/]+)(${D}*=${D}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), Y = /'/g, tt = /"/g, nt = /^(?:script|style|textarea|title)$/i, $ = Symbol.for("lit-noChange"), l = Symbol.for("lit-nothing"), et = /* @__PURE__ */ new WeakMap(), g = w.createTreeWalker(w, 129);
function at(o, t) {
  if (!q(o) || !o.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return G !== void 0 ? G.createHTML(t) : t;
}
const yt = (o, t) => {
  const e = o.length - 1, i = [];
  let r, s = t === 2 ? "<svg>" : t === 3 ? "<math>" : "", n = A;
  for (let d = 0; d < e; d++) {
    const a = o[d];
    let c, b, h = -1, f = 0;
    for (; f < a.length && (n.lastIndex = f, b = n.exec(a), b !== null); ) f = n.lastIndex, n === A ? b[1] === "!--" ? n = Q : b[1] !== void 0 ? n = X : b[2] !== void 0 ? (nt.test(b[2]) && (r = RegExp("</" + b[2], "g")), n = m) : b[3] !== void 0 && (n = m) : n === m ? b[0] === ">" ? (n = r ?? A, h = -1) : b[1] === void 0 ? h = -2 : (h = n.lastIndex - b[2].length, c = b[1], n = b[3] === void 0 ? m : b[3] === '"' ? tt : Y) : n === tt || n === Y ? n = m : n === Q || n === X ? n = A : (n = m, r = void 0);
    const v = n === m && o[d + 1].startsWith("/>") ? " " : "";
    s += n === A ? a + gt : h >= 0 ? (i.push(c), a.slice(0, h) + ot + a.slice(h) + x + v) : a + x + (h === -2 ? d : v);
  }
  return [at(o, s + (o[e] || "<?>") + (t === 2 ? "</svg>" : t === 3 ? "</math>" : "")), i];
};
class M {
  constructor({ strings: t, _$litType$: e }, i) {
    let r;
    this.parts = [];
    let s = 0, n = 0;
    const d = t.length - 1, a = this.parts, [c, b] = yt(t, e);
    if (this.el = M.createElement(c, i), g.currentNode = this.el.content, e === 2 || e === 3) {
      const h = this.el.content.firstChild;
      h.replaceWith(...h.childNodes);
    }
    for (; (r = g.nextNode()) !== null && a.length < d; ) {
      if (r.nodeType === 1) {
        if (r.hasAttributes()) for (const h of r.getAttributeNames()) if (h.endsWith(ot)) {
          const f = b[n++], v = r.getAttribute(h).split(x), H = /([.?@])?(.*)/.exec(f);
          a.push({ type: 1, index: s, name: H[2], strings: v, ctor: H[1] === "." ? _t : H[1] === "?" ? At : H[1] === "@" ? Et : N }), r.removeAttribute(h);
        } else h.startsWith(x) && (a.push({ type: 6, index: s }), r.removeAttribute(h));
        if (nt.test(r.tagName)) {
          const h = r.textContent.split(x), f = h.length - 1;
          if (f > 0) {
            r.textContent = T ? T.emptyScript : "";
            for (let v = 0; v < f; v++) r.append(h[v], C()), g.nextNode(), a.push({ type: 2, index: ++s });
            r.append(h[f], C());
          }
        }
      } else if (r.nodeType === 8) if (r.data === st) a.push({ type: 2, index: s });
      else {
        let h = -1;
        for (; (h = r.data.indexOf(x, h + 1)) !== -1; ) a.push({ type: 7, index: s }), h += x.length - 1;
      }
      s++;
    }
  }
  static createElement(t, e) {
    const i = w.createElement("template");
    return i.innerHTML = t, i;
  }
}
function _(o, t, e = o, i) {
  if (t === $) return t;
  let r = i !== void 0 ? e._$Co?.[i] : e._$Cl;
  const s = P(t) ? void 0 : t._$litDirective$;
  return r?.constructor !== s && (r?._$AO?.(!1), s === void 0 ? r = void 0 : (r = new s(o), r._$AT(o, e, i)), i !== void 0 ? (e._$Co ??= [])[i] = r : e._$Cl = r), r !== void 0 && (t = _(o, r._$AS(o, t.values), r, i)), t;
}
class $t {
  constructor(t, e) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = e;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    const { el: { content: e }, parts: i } = this._$AD, r = (t?.creationScope ?? w).importNode(e, !0);
    g.currentNode = r;
    let s = g.nextNode(), n = 0, d = 0, a = i[0];
    for (; a !== void 0; ) {
      if (n === a.index) {
        let c;
        a.type === 2 ? c = new U(s, s.nextSibling, this, t) : a.type === 1 ? c = new a.ctor(s, a.name, a.strings, this, t) : a.type === 6 && (c = new St(s, this, t)), this._$AV.push(c), a = i[++d];
      }
      n !== a?.index && (s = g.nextNode(), n++);
    }
    return g.currentNode = w, r;
  }
  p(t) {
    let e = 0;
    for (const i of this._$AV) i !== void 0 && (i.strings !== void 0 ? (i._$AI(t, i, e), e += i.strings.length - 2) : i._$AI(t[e])), e++;
  }
}
class U {
  get _$AU() {
    return this._$AM?._$AU ?? this._$Cv;
  }
  constructor(t, e, i, r) {
    this.type = 2, this._$AH = l, this._$AN = void 0, this._$AA = t, this._$AB = e, this._$AM = i, this.options = r, this._$Cv = r?.isConnected ?? !0;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const e = this._$AM;
    return e !== void 0 && t?.nodeType === 11 && (t = e.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, e = this) {
    t = _(this, t, e), P(t) ? t === l || t == null || t === "" ? (this._$AH !== l && this._$AR(), this._$AH = l) : t !== this._$AH && t !== $ && this._(t) : t._$litType$ !== void 0 ? this.$(t) : t.nodeType !== void 0 ? this.T(t) : wt(t) ? this.k(t) : this._(t);
  }
  O(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  T(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
  }
  _(t) {
    this._$AH !== l && P(this._$AH) ? this._$AA.nextSibling.data = t : this.T(w.createTextNode(t)), this._$AH = t;
  }
  $(t) {
    const { values: e, _$litType$: i } = t, r = typeof i == "number" ? this._$AC(t) : (i.el === void 0 && (i.el = M.createElement(at(i.h, i.h[0]), this.options)), i);
    if (this._$AH?._$AD === r) this._$AH.p(e);
    else {
      const s = new $t(r, this), n = s.u(this.options);
      s.p(e), this.T(n), this._$AH = s;
    }
  }
  _$AC(t) {
    let e = et.get(t.strings);
    return e === void 0 && et.set(t.strings, e = new M(t)), e;
  }
  k(t) {
    q(this._$AH) || (this._$AH = [], this._$AR());
    const e = this._$AH;
    let i, r = 0;
    for (const s of t) r === e.length ? e.push(i = new U(this.O(C()), this.O(C()), this, this.options)) : i = e[r], i._$AI(s), r++;
    r < e.length && (this._$AR(i && i._$AB.nextSibling, r), e.length = r);
  }
  _$AR(t = this._$AA.nextSibling, e) {
    for (this._$AP?.(!1, !0, e); t !== this._$AB; ) {
      const i = t.nextSibling;
      t.remove(), t = i;
    }
  }
  setConnected(t) {
    this._$AM === void 0 && (this._$Cv = t, this._$AP?.(t));
  }
}
class N {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t, e, i, r, s) {
    this.type = 1, this._$AH = l, this._$AN = void 0, this.element = t, this.name = e, this._$AM = r, this.options = s, i.length > 2 || i[0] !== "" || i[1] !== "" ? (this._$AH = Array(i.length - 1).fill(new String()), this.strings = i) : this._$AH = l;
  }
  _$AI(t, e = this, i, r) {
    const s = this.strings;
    let n = !1;
    if (s === void 0) t = _(this, t, e, 0), n = !P(t) || t !== this._$AH && t !== $, n && (this._$AH = t);
    else {
      const d = t;
      let a, c;
      for (t = s[0], a = 0; a < s.length - 1; a++) c = _(this, d[i + a], e, a), c === $ && (c = this._$AH[a]), n ||= !P(c) || c !== this._$AH[a], c === l ? t = l : t !== l && (t += (c ?? "") + s[a + 1]), this._$AH[a] = c;
    }
    n && !r && this.j(t);
  }
  j(t) {
    t === l ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
  }
}
class _t extends N {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === l ? void 0 : t;
  }
}
class At extends N {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    this.element.toggleAttribute(this.name, !!t && t !== l);
  }
}
class Et extends N {
  constructor(t, e, i, r, s) {
    super(t, e, i, r, s), this.type = 5;
  }
  _$AI(t, e = this) {
    if ((t = _(this, t, e, 0) ?? l) === $) return;
    const i = this._$AH, r = t === l && i !== l || t.capture !== i.capture || t.once !== i.once || t.passive !== i.passive, s = t !== l && (i === l || r);
    r && this.element.removeEventListener(this.name, this, i), s && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    typeof this._$AH == "function" ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
  }
}
class St {
  constructor(t, e, i) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = e, this.options = i;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    _(this, t);
  }
}
const Ct = j.litHtmlPolyfillSupport;
Ct?.(M, U), (j.litHtmlVersions ??= []).push("3.3.1");
const Pt = (o, t, e) => {
  const i = e?.renderBefore ?? t;
  let r = i._$litPart$;
  if (r === void 0) {
    const s = e?.renderBefore ?? null;
    i._$litPart$ = r = new U(t.insertBefore(C(), s), s, void 0, e ?? {});
  }
  return r._$AI(o), r;
};
const W = globalThis;
class S extends y {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    const t = super.createRenderRoot();
    return this.renderOptions.renderBefore ??= t.firstChild, t;
  }
  update(t) {
    const e = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = Pt(e, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    super.connectedCallback(), this._$Do?.setConnected(!0);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._$Do?.setConnected(!1);
  }
  render() {
    return $;
  }
}
S._$litElement$ = !0, S.finalized = !0, W.litElementHydrateSupport?.({ LitElement: S });
const Mt = W.litElementPolyfillSupport;
Mt?.({ LitElement: S });
(W.litElementVersions ??= []).push("4.2.1");
const Ut = { attribute: !0, type: String, converter: R, reflect: !1, hasChanged: V }, Ht = (o = Ut, t, e) => {
  const { kind: i, metadata: r } = e;
  let s = globalThis.litPropertyMetadata.get(r);
  if (s === void 0 && globalThis.litPropertyMetadata.set(r, s = /* @__PURE__ */ new Map()), i === "setter" && ((o = Object.create(o)).wrapped = !0), s.set(e.name, o), i === "accessor") {
    const { name: n } = e;
    return { set(d) {
      const a = t.get.call(this);
      t.set.call(this, d), this.requestUpdate(n, a, o);
    }, init(d) {
      return d !== void 0 && this.C(n, void 0, o, d), d;
    } };
  }
  if (i === "setter") {
    const { name: n } = e;
    return function(d) {
      const a = this[n];
      t.call(this, d), this.requestUpdate(n, a, o);
    };
  }
  throw Error("Unsupported decorator location: " + i);
};
function u(o) {
  return (t, e) => typeof e == "object" ? Ht(o, t, e) : ((i, r, s) => {
    const n = r.hasOwnProperty(s);
    return r.constructor.createProperty(s, i), n ? Object.getOwnPropertyDescriptor(r, s) : void 0;
  })(o, t, e);
}
const Ot = (o) => {
  class t extends o {
    constructor(...i) {
      super(...i), this._attachDeclarativeTemplate();
    }
    connectedCallback() {
      super.connectedCallback();
    }
    /**
     * Attempts to use a declarative shadow DOM template if provided.
     * If used, this bypasses Lit's standard rendering.
     */
    _attachDeclarativeTemplate() {
      const i = this.constructor;
      if (!i.template) return;
      const r = document.createElement("template");
      r.innerHTML = i.template.trim();
      const s = r.content.firstChild;
      if (s && s.nodeName === "TEMPLATE" && s.getAttribute("shadowrootmode") === "open") {
        const n = s, d = this.attachShadow({ mode: "open" }), a = n.content.cloneNode(!0);
        d.appendChild(a), this.__hasDeclarativeShadowRoot = !0;
      }
    }
    /**
     * Override createRenderRoot to prevent Lit's standard rendering
     * if we've already attached a declarative shadow DOM template
     */
    createRenderRoot() {
      return this.__hasDeclarativeShadowRoot ? this.shadowRoot : super.createRenderRoot();
    }
  }
  return t;
}, Rt = (o) => {
  class t extends o {
    connectedCallback() {
      super.connectedCallback(), this._bindDeclarativeEvents();
    }
    /**
     * Finds all elements with @event attributes and binds them to the corresponding methods
     */
    _bindDeclarativeEvents() {
      const i = this.shadowRoot;
      if (!i) return;
      const r = document.createTreeWalker(
        i,
        NodeFilter.SHOW_ELEMENT
      );
      let s = r.nextNode();
      for (; s; )
        Array.from(s.attributes).forEach((n) => {
          if (n.name.startsWith("@")) {
            const d = n.name.slice(1), a = n.value, c = this[a];
            typeof c == "function" ? s.addEventListener(d, c.bind(this)) : console.warn(
              `${this.localName}: no method '${a}' for event '${d}'`
            );
          }
        }), s = r.nextNode();
    }
  }
  return t;
}, Tt = (o) => Rt(Ot(o));
let it = 0;
const B = (o) => (it += 1, `${o}-${it}`);
var It = Object.defineProperty, k = (o, t, e, i) => {
  for (var r = void 0, s = o.length - 1, n; s >= 0; s--)
    (n = o[s]) && (r = n(t, e, r) || r);
  return r && It(t, e, r), r;
};
const dt = `<template shadowrootmode="open"><style>/*! tailwindcss v4.1.17 | MIT License | https://tailwindcss.com */
@layer properties{@supports ((-webkit-hyphens:none) and (not (margin-trim:inline))) or ((-moz-orient:inline) and (not (color:rgb(from red r g b)))){*,:before,:after,::backdrop{--tw-rotate-x:initial;--tw-rotate-y:initial;--tw-rotate-z:initial;--tw-skew-x:initial;--tw-skew-y:initial;--tw-shadow:0 0 #0000;--tw-shadow-color:initial;--tw-shadow-alpha:100%;--tw-inset-shadow:0 0 #0000;--tw-inset-shadow-color:initial;--tw-inset-shadow-alpha:100%;--tw-ring-color:initial;--tw-ring-shadow:0 0 #0000;--tw-inset-ring-color:initial;--tw-inset-ring-shadow:0 0 #0000;--tw-ring-inset:initial;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-offset-shadow:0 0 #0000;--tw-blur:initial;--tw-brightness:initial;--tw-contrast:initial;--tw-grayscale:initial;--tw-hue-rotate:initial;--tw-invert:initial;--tw-opacity:initial;--tw-saturate:initial;--tw-sepia:initial;--tw-drop-shadow:initial;--tw-drop-shadow-color:initial;--tw-drop-shadow-alpha:100%;--tw-drop-shadow-size:initial}}}.static{position:static}.isolate{isolation:isolate}.my-16{margin-block:var(--bdk-space-16,10.6667rem)}.mb-2{margin-bottom:var(--bdk-space-2,1.33333rem)}.block{display:block}.contents{display:contents}.flex{display:flex}.hidden{display:none}.inline{display:inline}.min-h-full{min-height:100%}.max-w-\\[500px\\]{max-width:500px}.transform{transform:var(--tw-rotate-x,)var(--tw-rotate-y,)var(--tw-rotate-z,)var(--tw-skew-x,)var(--tw-skew-y,)}.flex-col{flex-direction:column}.items-start{align-items:flex-start}.justify-center{justify-content:center}.gap-2{gap:var(--bdk-space-2,1.33333rem)}.gap-4{gap:var(--bdk-space-4,2.66667rem)}.overflow-y-scroll{overflow-y:scroll}.rounded-4{border-radius:var(--bdk-radius-4,2.66667rem)}.px-8{padding-inline:var(--bdk-space-8,5.33333rem)}.py-16{padding-block:var(--bdk-space-16,10.6667rem)}.bdk-tw-heading-s{letter-spacing:.05rem;text-transform:uppercase;font-family:Eduard Breuninger;font-size:2.66667rem;font-weight:500;line-height:4rem}.shadow{--tw-shadow:0 1px 3px 0 var(--tw-shadow-color,#0000001a),0 1px 2px -1px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.filter{filter:var(--tw-blur,)var(--tw-brightness,)var(--tw-contrast,)var(--tw-grayscale,)var(--tw-hue-rotate,)var(--tw-invert,)var(--tw-saturate,)var(--tw-sepia,)var(--tw-drop-shadow,)}:host{contain:layout;box-sizing:border-box;display:inline-block}.bdk-checkbox{--bdk-checkbox-input-background-color:var(--bdk-snow-100,#fff);--bdk-checkbox-input-border-width:1px;--bdk-checkbox-input-border-color:var(--bdk-coal-100,#1a1a1a);--bdk-checkbox-text-color:var(--bdk-coal-100,#1a1a1a);align-items:center;gap:var(--bdk-space-2,1.33333rem);display:flex}@media screen and (pointer:fine){.bdk-checkbox:has(input:where(:hover):not(:disabled)){--bdk-checkbox-input-border-color:var(--bdk-red-hover-light,#cb0d33);--bdk-checkbox-input-border-width:2px;--bdk-checkbox-text-color:var(--bdk-red-hover-light,#cb0d33);cursor:pointer}}.bdk-checkbox:has(input:where(:active):not(:disabled)){--bdk-checkbox-input-border-color:var(--bdk-red-hover-light,#cb0d33);--bdk-checkbox-input-border-width:2px;--bdk-checkbox-text-color:var(--bdk-red-hover-light,#cb0d33);cursor:pointer}.bdk-checkbox:has(input:disabled){--bdk-checkbox-input-border-color:var(--bdk-pebble,#e0dfde);--bdk-checkbox-text-color:var(--bdk-smoke,#928d8b);cursor:auto}.bdk-checkbox[multiline]{align-items:flex-start}.bdk-checkbox:has(input:checked){--bdk-checkbox-input-border-color:var(--bdk-coal-100,#1a1a1a);--bdk-checkbox-input-background-color:var(--bdk-coal-100,#1a1a1a);--bdk-checkbox-input-marker-transform:scale(1)}@media screen and (pointer:fine){.bdk-checkbox:has(input:checked:where(:hover):not(:disabled)){--bdk-checkbox-input-border-color:var(--bdk-red-hover-light,#cb0d33);--bdk-checkbox-input-background-color:var(--bdk-red-hover-light,#cb0d33);--bdk-checkbox-input-marker-transform:scale(.75)}}.bdk-checkbox:has(input:checked:where(:active):not(:disabled)){--bdk-checkbox-input-border-color:var(--bdk-red-hover-light,#cb0d33);--bdk-checkbox-input-background-color:var(--bdk-red-hover-light,#cb0d33);--bdk-checkbox-input-marker-transform:scale(.75)}@media screen and (pointer:fine){.bdk-checkbox:has(input:disabled):hover{--bdk-checkbox-input-border-color:var(--bdk-pebble,#e0dfde);--bdk-checkbox-input-border-width:1px;--bdk-checkbox-text-color:var(--bdk-smoke,#928d8b)}}.bdk-checkbox:has(input[aria-invalid=true]:not(:disabled)){--bdk-checkbox-input-border-color:var(--bdk-error,#b20c16);--bdk-checkbox-text-color:var(--bdk-error,#b20c16)}@media screen and (pointer:fine){.bdk-checkbox:has(input[aria-invalid=true]:not(:disabled)):hover{--bdk-checkbox-input-border-color:var(--bdk-red-hover-light,#cb0d33);--bdk-checkbox-text-color:var(--bdk-red-hover-light,#cb0d33)}}.bdk-checkbox:has(input:disabled:checked){--bdk-checkbox-input-background-color:var(--bdk-pebble,#e0dfde)}@media screen and (pointer:fine){.bdk-checkbox:has(input:disabled:checked):hover{--bdk-checkbox-input-background-color:var(--bdk-pebble,#e0dfde)}}:host([multiline]) .bdk-checkbox{align-items:flex-start}:host([inverted]) .bdk-checkbox{--bdk-checkbox-input-border-color:var(--bdk-snow-100);--bdk-checkbox-text-color:var(--bdk-snow-100);border-radius:var(--bdk-space-2);margin:calc(-1*var(--bdk-space-2));padding:var(--bdk-space-2)}:host([inverted]) .bdk-checkbox:has(input:checked){--bdk-checkbox-input-border-color:var(--bdk-snow-100);--bdk-checkbox-input-background-color:var(--bdk-coal-100);--bdk-checkbox-text-color:var(--bdk-snow-100)}:host([inverted]) .bdk-checkbox:has(input:checked:active:not(:disabled)){--bdk-checkbox-input-border-color:var(--bdk-coal-100);--bdk-checkbox-input-background-color:var(--bdk-snow-100);--bdk-checkbox-text-color:var(--bdk-snow-100);--bdk-checkbox-input-marker-transform:scale(1)}:host([inverted]) .bdk-checkbox:has(input:checked:active:not(:disabled)) .bdk-checkbox--input:before{filter:brightness(0)}@media screen and (pointer:fine){:host([inverted]) .bdk-checkbox:has(input:hover:not(:disabled)),:host([inverted]) .bdk-checkbox:has(input:checked:hover:not(:disabled)){--bdk-checkbox-input-border-color:var(--bdk-coal-100);--bdk-checkbox-text-color:var(--bdk-snow-100)}:host([inverted]) .bdk-checkbox:has(input:checked:hover:not(:disabled)){--bdk-checkbox-input-background-color:var(--bdk-snow-100);--bdk-checkbox-input-marker-transform:scale(1)}:host([inverted]) .bdk-checkbox:has(input:checked:hover:not(:disabled)) .bdk-checkbox--input:before{filter:brightness(0)}}:host([inverted]) .bdk-checkbox:has(input:active:not(:disabled)){--bdk-checkbox-input-border-color:var(--bdk-coal-100);--bdk-checkbox-text-color:var(--bdk-snow-100)}:host([inverted]) .bdk-checkbox:has(input[aria-invalid=true]:not(:disabled)){--bdk-checkbox-input-border-color:var(--bdk-error);--bdk-checkbox-text-color:var(--bdk-error);background-color:var(--bdk-error-background)}@media screen and (pointer:fine){:host([inverted]) .bdk-checkbox:has(input[aria-invalid=true]:not(:disabled)):hover{--bdk-checkbox-input-border-color:var(--bdk-error);--bdk-checkbox-text-color:var(--bdk-error)}}:host([inverted]) .bdk-checkbox:has(input:disabled){--bdk-checkbox-input-border-color:var(--bdk-snow-25,#ffffff40);--bdk-checkbox-text-color:var(--bdk-snow-50,#ffffff80);--bdk-checkbox-input-background-color:var(--bdk-snow-50,#ffffff80)}:host([inverted]) .bdk-checkbox:has(input:disabled:not(:checked)) .bdk-checkbox--input:before{display:none}@media screen and (pointer:fine){:host([inverted]) .bdk-checkbox:has(input:disabled):hover{--bdk-checkbox-input-border-color:var(--bdk-snow-25,#ffffff40);--bdk-checkbox-text-color:var(--bdk-snow-50,#ffffff80);--bdk-checkbox-input-background-color:var(--bdk-snow-50,#ffffff80)}}:host([inverted]) .bdk-checkbox:has(input:disabled:checked){--bdk-checkbox-input-border-color:var(--bdk-snow-25,#ffffff40);--bdk-checkbox-text-color:var(--bdk-snow-50,#ffffff80);--bdk-checkbox-input-background-color:var(--bdk-snow-50,#ffffff80)}@media screen and (pointer:fine){:host([inverted]) .bdk-checkbox:has(input:disabled:checked):hover{--bdk-checkbox-input-border-color:var(--bdk-snow-25,#ffffff40);--bdk-checkbox-text-color:var(--bdk-snow-50,#ffffff80);--bdk-checkbox-input-background-color:var(--bdk-snow-50,#ffffff80)}}.bdk-checkbox--input{width:var(--bdk-space-5,3.33333rem);height:var(--bdk-space-5,3.33333rem);background-color:var(--bdk-checkbox-input-background-color);border:var(--bdk-checkbox-input-border-width)solid var(--bdk-checkbox-input-border-color);border-radius:var(--bdk-space-1,.666667rem);-webkit-appearance:none;-moz-appearance:none;appearance:none;transition:background-color var(--bdk-transition-duration-default,.2s)ease,border-color var(--bdk-transition-duration-default,.2s)ease;flex-shrink:0;place-content:center;display:grid}.bdk-checkbox--input:before{content:"";width:var(--bdk-space-4,2.66667rem);height:var(--bdk-space-4,2.66667rem);transform:var(--bdk-checkbox-input-marker-transform);transition:transform var(--bdk-transition-duration-default,.2s)ease;background-image:url("data:image/svg+xml;utf8,<svg width=\\"16\\" height=\\"16\\" viewBox=\\"0 0 16 16\\" fill=\\"none\\" xmlns=\\"http://www.w3.org/2000/svg\\"><path d=\\"M3.11108 7.99983l4 3.55557L12.8889 4.44427\\" stroke=\\"white\\" stroke-width=\\"1.5\\" stroke-miterlimit=\\"10\\" stroke-linecap=\\"square\\"/></svg>")}.bdk-checkbox--input:not(:disabled):focus-visible{outline:2px solid var(--bdk-focus-color);outline-offset:2px;box-shadow:0 0 0 3px var(--bdk-focus-background-color)}.bdk-checkbox--input:not(:disabled)[inverted]:focus-visible{outline:2px solid var(--bdk-focus-color-inverted);outline-offset:2px;box-shadow:0 0 0 3px var(--bdk-focus-background-color-inverted)}@media (prefers-reduced-motion:reduce){.bdk-checkbox--input,.bdk-checkbox--input:before{transition:none}}.bdk-checkbox--input{cursor:pointer}.bdk-checkbox--text{font-family:var(--bdk-text-m-font-family,"Eduard Breuninger",Helvetica,Arial,sans-serif);font-size:var(--bdk-text-m-font-size,2.66667rem);font-weight:var(--bdk-text-m-font-weight,400);letter-spacing:var(--bdk-text-m-letter-spacing,.066667rem);line-height:var(--bdk-text-m-line-height,4rem);-webkit-text-decoration:var(--bdk-text-m-text-decoration,none);-webkit-text-decoration:var(--bdk-text-m-text-decoration,none);text-decoration:var(--bdk-text-m-text-decoration,none);text-transform:var(--bdk-text-m-text-transform,inherit);color:var(--bdk-checkbox-text-color);width:100%}:host([size=small]) .bdk-checkbox--text{font-family:var(--bdk-text-s-font-family,"Eduard Breuninger",Helvetica,Arial,sans-serif);font-size:var(--bdk-text-s-font-size,2.33333rem);font-weight:var(--bdk-text-s-font-weight,400);letter-spacing:var(--bdk-text-s-letter-spacing,.05rem);line-height:var(--bdk-text-s-line-height,3.66667rem);-webkit-text-decoration:var(--bdk-text-s-text-decoration,none);-webkit-text-decoration:var(--bdk-text-s-text-decoration,none);text-decoration:var(--bdk-text-s-text-decoration,none);text-transform:var(--bdk-text-s-text-transform,inherit);color:var(--bdk-checkbox-text-color)}.bdk-checkbox--error,.bdk-checkbox--hint{margin-top:var(--bdk-space-1,.666667rem);margin-left:calc(var(--bdk-space-8) + 3px)}.bdk-checkbox--hint{font-family:var(--bdk-text-m-font-family,"Eduard Breuninger",Helvetica,Arial,sans-serif);font-size:var(--bdk-text-m-font-size,2.66667rem);font-weight:var(--bdk-text-m-font-weight,400);letter-spacing:var(--bdk-text-m-letter-spacing,.066667rem);line-height:var(--bdk-text-m-line-height,4rem);-webkit-text-decoration:var(--bdk-text-m-text-decoration,none);-webkit-text-decoration:var(--bdk-text-m-text-decoration,none);text-decoration:var(--bdk-text-m-text-decoration,none);text-transform:var(--bdk-text-m-text-transform,inherit);color:var(--bdk-checkbox-text-color)}:host([invalid]) .bdk-checkbox--hint{--bdk-checkbox-text-color:var(--bdk-error)}:host([size=small]) .bdk-checkbox--hint{font-family:var(--bdk-text-s-font-family,"Eduard Breuninger",Helvetica,Arial,sans-serif);font-size:var(--bdk-text-s-font-size,2.33333rem);font-weight:var(--bdk-text-s-font-weight,400);letter-spacing:var(--bdk-text-s-letter-spacing,.05rem);line-height:var(--bdk-text-s-line-height,3.66667rem);-webkit-text-decoration:var(--bdk-text-s-text-decoration,none);-webkit-text-decoration:var(--bdk-text-s-text-decoration,none);text-decoration:var(--bdk-text-s-text-decoration,none);text-transform:var(--bdk-text-s-text-transform,inherit);color:var(--bdk-checkbox-text-color)}.bdk-checkbox--error{letter-spacing:.066667rem;text-transform:inherit;color:var(--bdk-error,#b20c16);font-family:Eduard Breuninger;font-size:2.66667rem;font-weight:500;line-height:4rem}:host([size=small]) .bdk-checkbox--error{letter-spacing:.05rem;text-transform:inherit;font-family:Eduard Breuninger;font-size:2.33333rem;font-weight:500;line-height:3.66667rem}@property --tw-rotate-x{syntax:"*";inherits:false}@property --tw-rotate-y{syntax:"*";inherits:false}@property --tw-rotate-z{syntax:"*";inherits:false}@property --tw-skew-x{syntax:"*";inherits:false}@property --tw-skew-y{syntax:"*";inherits:false}@property --tw-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-shadow-color{syntax:"*";inherits:false}@property --tw-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-inset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-shadow-color{syntax:"*";inherits:false}@property --tw-inset-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-ring-color{syntax:"*";inherits:false}@property --tw-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-ring-color{syntax:"*";inherits:false}@property --tw-inset-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-ring-inset{syntax:"*";inherits:false}@property --tw-ring-offset-width{syntax:"<length>";inherits:false;initial-value:0}@property --tw-ring-offset-color{syntax:"*";inherits:false;initial-value:#fff}@property --tw-ring-offset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-blur{syntax:"*";inherits:false}@property --tw-brightness{syntax:"*";inherits:false}@property --tw-contrast{syntax:"*";inherits:false}@property --tw-grayscale{syntax:"*";inherits:false}@property --tw-hue-rotate{syntax:"*";inherits:false}@property --tw-invert{syntax:"*";inherits:false}@property --tw-opacity{syntax:"*";inherits:false}@property --tw-saturate{syntax:"*";inherits:false}@property --tw-sepia{syntax:"*";inherits:false}@property --tw-drop-shadow{syntax:"*";inherits:false}@property --tw-drop-shadow-color{syntax:"*";inherits:false}@property --tw-drop-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-drop-shadow-size{syntax:"*";inherits:false}
</style>
  
  <label class="bdk-checkbox">
    <input type="checkbox" class="bdk-checkbox--input" />
    <span class="bdk-checkbox--text">
      <slot></slot>
    </span>
  </label>

  <div class="bdk-checkbox--hint" hidden>
    <slot name="hint"></slot>
  </div>

  <div class="bdk-checkbox--error" hidden>
    <slot name="error"></slot>
  </div>
</template>`;
function Nt() {
  return dt;
}
const I = class I extends Tt(S) {
  constructor() {
    super(...arguments), this.internals = this.attachInternals(), this.value = "on", this.disabled = !1, this.inverted = !1, this.name = "", this.readonly = !1, this.required = !1, this.size = "medium", this.checked = !1, this.invalid = !1, this.inputId = B("bdk-checkbox"), this.hintId = B("bdk-checkbox-hint"), this.errorId = B("bdk-checkbox-error"), this.hintSlotChangeCallback = () => {
      this.hintSlot.assignedElements().length > 0 ? (this.hint.removeAttribute("hidden"), this.input.setAttribute("aria-describedby", this.hintId)) : (this.hint.setAttribute("hidden", ""), this.input.removeAttribute("aria-describedby"));
    };
  }
  get form() {
    return this.internals.form;
  }
  /* Getter seems to work after connecting, @query does not */
  get input() {
    return this.shadowRoot.querySelector("input");
  }
  get hint() {
    return this.shadowRoot.querySelector(".bdk-checkbox--hint");
  }
  get hintSlot() {
    return this.shadowRoot.querySelector("slot[name=hint]");
  }
  get error() {
    return this.shadowRoot.querySelector(".bdk-checkbox--error");
  }
  get errorSlot() {
    return this.shadowRoot.querySelector("slot[name=error]");
  }
  get label() {
    return this.shadowRoot.querySelector("label");
  }
  firstUpdated(t) {
    super.firstUpdated(t), this.setIds(), this.setupEventHandling(), this.hintSlotChangeCallback();
  }
  updated(t) {
    super.updated(t), t.has("checked") && (this.input.checked = this.checked, this._setFormValueAndValidity()), t.has("value") && (this.input.value = this.value, this._setFormValueAndValidity()), this._setBooleanAttributeIfChanged(t, "disabled"), this._setBooleanAttributeIfChanged(t, "required"), this._setBooleanAttributeIfChanged(t, "readonly"), this._setBooleanAttributeIfChanged(t, "inverted"), this._setAttributeIfChanged(t, "name"), this._setAttributeIfChanged(t, "size"), t.has("invalid") && (this.invalid ? this._handleInvalidState() : this._unsetValidationState());
  }
  _handleInvalidState() {
    const t = this.input.getAttribute("aria-describedby");
    this._hintHasInteractiveContent() || this.hint.setAttribute("hidden", ""), this.input.setAttribute("aria-invalid", "true"), this.input.setAttribute(
      "aria-describedby",
      [t, this.errorId].join(" ").trim()
    ), this.errorSlot.assignedElements().length > 0 && this.error.removeAttribute("hidden");
  }
  _unsetValidationState() {
    this.error.setAttribute("hidden", ""), this.input.removeAttribute("aria-invalid"), this.hintSlotChangeCallback();
  }
  _hintHasInteractiveContent() {
    return this.hintSlot.assignedElements().some((t) => t.querySelector("a,button") || t.matches("a,button"));
  }
  _setAttributeIfChanged(t, e) {
    if (!t.has(e)) return;
    const i = this[e];
    i ? this.input.setAttribute(e, i) : this.input.removeAttribute(e);
  }
  _setBooleanAttributeIfChanged(t, e) {
    if (!t.has(e)) return;
    this[e] ? this.input.setAttribute(e, "") : this.input.removeAttribute(e);
  }
  _setFormValueAndValidity() {
    this.checked ? (this.internals.setFormValue(this.value), this.input.setAttribute("checked", "")) : (this.internals.setFormValue(null), this.input.removeAttribute("checked")), this.internals.setValidity(
      this.input.validity,
      this.input.validationMessage,
      this.input
    );
  }
  setIds() {
    this.input.setAttribute("id", this.inputId), this.hint.setAttribute("id", this.hintId), this.label.setAttribute("for", this.inputId), this.error.setAttribute("id", this.errorId);
  }
  setupEventHandling() {
    this.input.addEventListener("change", this.handleChange.bind(this)), this.input.addEventListener("click", this.handleClick.bind(this)), this.hintSlot.addEventListener("slotchange", this.hintSlotChangeCallback);
  }
  handleClick(t) {
    this.readonly && t.preventDefault();
  }
  handleChange() {
    this.readonly || (this.checked = this.input.checked, this._setFormValueAndValidity(), this.dispatchEvent(
      new Event("change", {
        bubbles: !0,
        composed: !0
      })
    ));
  }
};
I.template = dt, I.formAssociated = !0;
let p = I;
k([
  u({ reflect: !0 })
], p.prototype, "value");
k([
  u({ type: Boolean, reflect: !0 })
], p.prototype, "disabled");
k([
  u({ type: Boolean, reflect: !0 })
], p.prototype, "inverted");
k([
  u({ reflect: !0, type: String })
], p.prototype, "name");
k([
  u({ type: Boolean, reflect: !0 })
], p.prototype, "readonly");
k([
  u({ type: Boolean, reflect: !0 })
], p.prototype, "required");
k([
  u({ type: String, reflect: !0 })
], p.prototype, "size");
k([
  u({ type: Boolean, reflect: !0 })
], p.prototype, "checked");
k([
  u({ type: Boolean, reflect: !0 })
], p.prototype, "invalid");
k([
  u({ type: String, reflect: !1, attribute: "input-id" })
], p.prototype, "inputId");
k([
  u({ type: String, reflect: !1, attribute: "hint-id" })
], p.prototype, "hintId");
k([
  u({ type: String, reflect: !1, attribute: "error-id" })
], p.prototype, "errorId");
export {
  p as BdkCheckbox,
  dt as default,
  Nt as dsd
};
